<template>
  <div class="detail-wrap">
    <div class="yto-box" style="padding-top: 10px;">
      <el-form :inline="true" :model="form" ref="ruleForm" label-width="100px">
        <el-form-item prop="dateType">
          <el-select :popper-append-to-body="false" class="y-w-160" v-model="form.dateType">
            <el-option label="取号时间" value="0"></el-option>
            <el-option label="操作回收时间" value="1"></el-option>
            <el-option label="回收时间" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="createTime">
          <yto-date-picker
            customDaysName="facesheetRecyclingPDetail"
            :curShortcutName="curShortcutName"
            :maxRangeVal="31"
            class="y-w-320"
            :picker-options="pickerOptions"
            :clearable="false"
            :editable="false"
            :default-time="['00:00:00', '23:59:59']"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy.MM.dd HH:mm"
            v-model="form.createTime"
            type="datetimerange"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></yto-date-picker>
        </el-form-item>
        <el-form-item prop="platformCode">
          <el-select
            clearable
            :popper-append-to-body="false"
            class="y-w-160"
            @change="getPlatformMallList"
            v-model="form.platformCode"
            placeholder="请选择平台">
            <el-option label="抖音" value="LUBAN"></el-option>
            <el-option label="拼多多" value="PDD"></el-option>
            <el-option label="快手" value="KS"></el-option>
            <el-option label="淘宝" value="TAOBAO"></el-option>
            <el-option label="1688" value="ALI_1688"></el-option>
            <el-option label="京东" value="JD"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="orderMallCode">
          <el-select
            clearable
            :disabled="!form.platformCode"
            :popper-append-to-body="false"
            class="y-w-160"
            v-model="form.orderMallCode"
            placeholder="请选择店铺">
            <el-option v-for="item in shopList" :key="item.mallCode" :label="item.mallName" :value="item.mallCode">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="cpCode">
          <el-select
            clearable
            :popper-append-to-body="false"
            class="y-w-160"
            v-model="form.cpCode"
            placeholder="请选择快递公司">
            <el-option label="圆通速递" value="YTO"></el-option>
            <el-option label="中通速递" value="ZTO"></el-option>
            <el-option label="韵达快递" value="YUNDA"></el-option>
            <el-option label="申通快递" value="STO"></el-option>
            <el-option label="顺丰速运" value="SF"></el-option>
            <el-option label="EMS" value="EMS"></el-option>
            <el-option label="邮政快递包裹" value="YZKDBG"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="recycleStatus">
          <el-select
            clearable
            :popper-append-to-body="false"
            class="y-w-160"
            v-model="form.recycleStatus"
            placeholder="请选择单号状态">
            <el-option label="回收中" value="0"></el-option>
            <el-option label="已回收" value="1"></el-option>
            <el-option label="平台回收成功" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <waybill-input v-model="form.mailNos" placeholder="请输入运单号" />
        </el-form-item>
        <el-form-item class="y-f-r">
          <el-button type="primary" @click="searchClick" icon="el-icon-search">查询</el-button>
          <el-button class="normal-btn" @click="resetForm('ruleForm')" icon="el-icon-refresh-left">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="yto-table">
      <el-table :data="tableData" height="calc(100vh - 300px)" v-loading="loading">
        <el-table-column prop="mailNo" label="运单号"></el-table-column>
        <el-table-column label="单号类型">
          <template slot-scope="scope">
            {{ WAYBILLNAMEMAP[scope.row.mailType] }}
          </template>
        </el-table-column>
        <el-table-column prop="waybillAccountName" label="运单所属店铺"></el-table-column>
        <el-table-column prop="orderNo" label="订单号"></el-table-column>
        <el-table-column label="平台类型">
          <template slot-scope="scope">
            {{ PLATFORMNAMEMAP[scope.row.platformCode] }}
          </template>
        </el-table-column>
        <el-table-column prop="orderMallName" label="订单所属店铺"></el-table-column>
        <el-table-column label="快递公司">
          <template slot-scope="scope">
            {{ CPCODEMAP[scope.row.cpCode] }}
          </template>
        </el-table-column>
        <el-table-column label="单号状态">
          <template slot-scope="scope">
            {{ scope.row.recycleStatus === 0 ? '回收中' : scope.row.recycleStatus === 1 ? '已回收' : '平台回收成功' }}
          </template>
        </el-table-column>
        <el-table-column prop="opertionRecycleTime" label="操作回收时间"></el-table-column>
        <el-table-column prop="fetchWaybillTime" label="取号时间"></el-table-column>
        <el-table-column prop="recycleTime" label="回收时间"></el-table-column>
      </el-table>
      <el-pagination
        @size-change="limitChange"
        @current-change="getDataList"
        :current-page.sync="pageNum"
        :page-sizes="[50, 100, 200, 300, 400]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import { getStoreListApi } from '../../../../api/baseInfo/shopManage/storeManagement';
import { platQueryOrderApi } from '../../../../api/statisticalAnalysis/facesheetRecycling/detailSearch';
import { getJdMallListApi } from '../../../../api/waybillPrint/jdPrint';
import { getPddStoreListApi } from '../../../../api/waybillPrint/pddPrint';
import { getTbAliStoreListApi } from '../../../../api/waybillPrint/taobaoPrintNew';
import { CPCODEMAP, PLATFORMNAMEMAP, WAYBILLNAMEMAP } from '../../../../utils/globalConfig';
import { dateFormat, getShortcutsMap, YTOSHORTCUTS } from '../../../../utils/util';
export default {
  data() {
    return {
      curShortcutName: 'today',
      pickerOptions: {
        ...YTOSHORTCUTS,
        disabledDate(time) {
          return (
            time.getTime() > new Date(`${dateFormat(new Date(), 'yyyy-MM-dd')} 23:59:59`).getTime() ||
            time.getTime() < new Date(new Date().getTime() - 60 * 24 * 3600000)
          );
        }
      },
      form: {
        dateType: '0', // 0 取号时间 1 操作回收时间  2 回收时间
        createTime: [],
        platformCode: '', // 平台类型
        orderMallCode: '',
        cpCode: '',
        recycleStatus: '',
        mailNos: '', // 运单号
      },
      pageNum: 1,
      pageSize: 50,
      loading: false,
      total: 0,
      tableData: [],
      PLATFORMNAMEMAP,
      WAYBILLNAMEMAP,
      CPCODEMAP,
      shopList: [],
    }
  },
  components: {
    waybillInput: () => import('@/components/printRelated/waybillInput')
  },
  mounted() {
    this.initTime();
    this.searchClick();
  },
  computed: {
    userMess() {
      return this.$store.state.user;
    }
  },
  methods: {
    // 初始化时间
    initTime() {
      let createTime = [];
      let agoDays = '';
      if(localStorage.getItem('facesheetRecyclingPDetail')) {
        let customrange = JSON.parse(localStorage.getItem('facesheetRecyclingPDetail'));
        agoDays = new Date(new Date().getTime() - customrange.dateRange * 24 * 3600 * 1000);
        this.curShortcutName = customrange.curShortcutName;
        if(this.curShortcutName === 'customRange') {
          // 只有是记住天数选项才使用记住的那个天数时间
          createTime = [
            `${dateFormat(agoDays, 'yyyy-MM-dd')} 00:00:00`,
            `${dateFormat(new Date(), 'yyyy-MM-dd')} 23:59:59`
          ]
        } else {
          let shortcutsMap = getShortcutsMap();
          createTime = shortcutsMap[this.curShortcutName];
        }
      } else {
        let shortcutsMap = getShortcutsMap();
        createTime = shortcutsMap[this.curShortcutName];
      }
      this.form.createTime = createTime;
    },
    // 查询电商平台店铺列表
    getPlatformMallList() {
      this.shopList = [];
      this.form.orderMallCode = '';
      if(!this.form.platformCode) return;
      this.getStoreNameList(this.form.platformCode).then(list => {
        this.shopList = list; // 获取正常店铺列表
        if(this.shopList.length > 0) {
          this.form.orderMallCode = this.shopList[0].mallCode;
        }
      });
    },
    getStoreNameList(paltformCode) {
      // 查询条件——店铺名称选项获取
      return new Promise(resolve => {
        let loadingMask = this.$loading({
          lock: true,
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.3)'
        });
        if(paltformCode === 'TAOBAO' || paltformCode === 'ALI_1688') {
          // 淘宝单独处理
          let params = {
            userId: this.userMess.loginId,
            paltformCode,
            status: "Y", // 已授权
            expiredStatus: 0, // 授权未过期
            limit: 10000,
            pageNo: 1
          }
          getTbAliStoreListApi(params).then((res) => {
            if (res.message === 'ok') {
              resolve(res.data.items || []);
            } else {
              resolve([]);
            }
            loadingMask.close();
          }).catch(() => {
            loadingMask.close();
            resolve([]);
          });
        } else if(paltformCode === 'PDD') {
          let params = {
            userId: this.userMess.loginId,
            paltformCode,
            status: "Y",
            expiredStatus: 0,
            limit: 10000,
            pageNo: 1
          }
          getPddStoreListApi(params).then(res => {
            if (res.message === 'ok') {
              resolve(res.data.items || []);
            } else {
              resolve([]);
            }
            loadingMask.close();
          }).catch(() => {
            loadingMask.close();
            resolve([]);
          });
        } else if(paltformCode === 'JD') {
          let params = {
            userId: this.userMess.loginId,
            paltformCode,
            status: "Y", // 已授权
            expiredStatus: 0, // 授权未过期
            limit: 10000,
            pageNo: 1
          }
          getJdMallListApi(params).then(res => {
            if (res.message === 'ok') {
              resolve(res.data.items || []);
            } else {
              resolve([]);
            }
            loadingMask.close();
          }).catch(() => {
            loadingMask.close();
            resolve([]);
          });
        } else {
          let params = {
            limit: 20000,
            pageNo: 1,
            status: 'Y',
            expiredStatus: 0,
            paltformCode
          };
          getStoreListApi(params).then((res) => {
            if (res.message === 'ok') {
              resolve(res.data.items || []);
            } else {
              resolve([]);
            }
            loadingMask.close();
          }).catch(() => {
            loadingMask.close();
            resolve([]);
          });
        }
      });
    },
    limitChange(val) {
      this.pageSize = val;
      this.searchClick();
    },
    searchClick() {
      this.pageNum = 1;
      this.getDataList();
    },
    getDataList() {
      let mailNos = [];
      let arr =  this.form.mailNos?this.form.mailNos.split(/[(\r\n)\r\n]+/):[];
      let arr1 = [];
      arr.forEach(function (r) {
        arr1.push(r.split(','));
      });
      arr1 = [].concat(...arr1);
      arr.length = 0;
      arr1.forEach(function (t) {
        arr.push(t.split('，'));
      });
      arr = [].concat(...arr);
      mailNos = arr.filter((item) =>{
        return item && item.trim()
      });
      let falseFlag = false;
      let lengthFlag = false;
      mailNos.forEach((r) => {
        if (r) {
          r = r.replace(/\s+/g, '');// 去所有空格
          let reg = /^[A-Za-z0-9]+$/; // 匹配由数字和26个英文字母组成的字符串
          if (!reg.test(r)) {
            falseFlag = true;
          }
          if (r.length > 20) {
            lengthFlag = true;
          }
        }
      });
      if (falseFlag) {
        this.$message.error('运单号只能输入字母及数字');
        return false;
      }
      if (lengthFlag) {
        this.$message.error('运单号不得超过20位');
        return false;
      }
      let params = {
        dateType: this.form.dateType,
        startTime: this.form.createTime[0],
        endTime: this.form.createTime[1],
        platformCode: this.form.platformCode,
        orderMallCode: this.form.orderMallCode ? [this.form.orderMallCode] : [],
        cpCode: this.form.cpCode,
        recycleStatus: this.form.recycleStatus,
        mailNos,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      };
      this.loading = true;
      platQueryOrderApi(params).then(res => {
        if(res.status === 200) {
          this.tableData = (res.data && res.data.resultData) || [];
          this.total = (res.data && res.data.total) || 0;
        } else {
          this.$message.error(res.message || '查询失败');
          this.tableData = [];
          this.total = 0;
        }
      }).catch(() => {
        this.$message.error('服务器错误');
        this.tableData = [];
        this.total = 0;
      }).finally(() => {
        this.loading = false;
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.initTime();
      this.form.mailNos = '';
      this.searchClick();
    },
  }
}
</script>
<style lang="scss" scoped>
.detail-wrap {
  min-height: calc(100vh - 150px);
}
</style>
